const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");
const productionApiBaseUrl = "https://api.letsroave.com/api";
const productionSearchApiBaseUrl = "https://search.letsroave.com";
const productionSiteBaseUrl = "https://www.letsroave.com";

const appEnv = (process.env.APP_ENV || process.env.NEXT_PUBLIC_X_ENV || "").toLowerCase();
const isProduction = appEnv === "prod" || appEnv === "production";

export const ROAVE_API_BASE_URL = trimTrailingSlash(
  isProduction ? productionApiBaseUrl : process.env.NEXT_PUBLIC_API_URL || productionApiBaseUrl
);

export const ROAVE_SEARCH_API_BASE_URL = trimTrailingSlash(
  isProduction
    ? productionSearchApiBaseUrl
    : process.env.NEXT_PUBLIC_SEARCH_API_URL || productionSearchApiBaseUrl
);

export const ROAVE_SITE_BASE_URL = trimTrailingSlash(
  isProduction ? productionSiteBaseUrl : process.env.NEXT_PUBLIC_BASE_URL || productionSiteBaseUrl
);
